import { useEffect } from "react";

const MEDIA_TAGS = new Set(["IMG", "VIDEO", "PICTURE", "FIGURE", "SOURCE"]);

const isMedia = (target) => {
  let el = target;
  while (el && el !== document.body) {
    if (MEDIA_TAGS.has(el.tagName) || el.dataset?.protected !== undefined) return true;
    el = el.parentElement;
  }
  return false;
};

export const useMediaProtection = () => {
  useEffect(() => {
    const onContext = (e) => {
      if (isMedia(e.target)) e.preventDefault();
    };
    const onDrag = (e) => {
      if (isMedia(e.target)) e.preventDefault();
    };
    const onKey = (e) => {
      const mod = e.ctrlKey || e.metaKey;
      if (!mod) return;
      const k = e.key.toLowerCase();
      if (k === "s" || k === "u" || (e.shiftKey && k === "s")) e.preventDefault();
    };
    document.addEventListener("contextmenu", onContext);
    document.addEventListener("dragstart", onDrag);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("contextmenu", onContext);
      document.removeEventListener("dragstart", onDrag);
      document.removeEventListener("keydown", onKey);
    };
  }, []);
};
